import { logEvent } from '@eventbrite/statsig';
import loadable from '@loadable/component';
import React, { useState } from 'react';
import { LISTING_HEAP_IDS, STATSIG_EVENT_NAMES } from '../../../../constants';
import { LocalizedDateTime, SeriesDatesScopedProps } from '../../../../types';
import { getFormattedDateCard } from '../../../utils/localizedDates';
import { shouldShowMoreOptions } from '../DateAndTime/utils';
import './ChildEventsSlider.scss';
import { DateCard, MoreOptionsCard } from './SliderCard';

const CHILD_EVENTS_THRESHOLD = 5;

const filterEventDates = ({ childEvents, eventId }: SeriesDatesScopedProps) => {
    const eventDates = [];
    const slicedEventDates = childEvents.slice(0, CHILD_EVENTS_THRESHOLD);

    for (let i = 0; i < slicedEventDates.length; i++) {
        const item = childEvents[i];

        eventDates.push({
            value: item.id,
            url: item.url,
            display: getFormattedDateCard({
                date: item.start,
                locale: item.locale,
            }),
            selected: item.id === eventId,
        });
    }
    return eventDates;
};

const LazyMoreOptionsModal = loadable(
    () => import('./MoreOptionsModal/MoreOptionsModal'),
);

export type ChildEventsSliderProps = SeriesDatesScopedProps & {
    currentEventStartDate: LocalizedDateTime;
    currentEventId: string;
};

export const ChildEventsSlider = ({
    childEvents,
    currentEventStartDate,
    currentEventId,
}: ChildEventsSliderProps) => {
    const [moreOptionsModalOpened, setMoreOptionsModalOpened] = useState(false);
    const filteredEventDates = filterEventDates({
        childEvents,
        eventId: currentEventId,
    });

    return (
        <>
            <div className="child-event-dates">
                <ul
                    className="child-event-dates-list"
                    data-testid="child-events-slider"
                >
                    {filteredEventDates.map(
                        ({ value, display, url, selected }) => {
                            return (
                                <li
                                    key={value}
                                    className="child-event-dates-item"
                                >
                                    <DateCard
                                        url={url}
                                        datesToDisplay={display}
                                        selected={selected}
                                    />
                                </li>
                            );
                        },
                    )}

                    {childEvents && shouldShowMoreOptions(childEvents) && (
                        <li
                            className="child-event-dates-item"
                            data-heap-id={LISTING_HEAP_IDS.MORE_OPTIONS_CARD}
                        >
                            <MoreOptionsCard
                                onButtonClick={() => {
                                    setMoreOptionsModalOpened(true);
                                    logEvent(
                                        STATSIG_EVENT_NAMES.MORE_OPTIONS_CARD,
                                    );
                                }}
                            />
                        </li>
                    )}
                </ul>
            </div>
            {moreOptionsModalOpened && (
                <LazyMoreOptionsModal
                    onClose={() => setMoreOptionsModalOpened(false)}
                    opened={moreOptionsModalOpened}
                    childEvents={childEvents}
                    currentEventStartDate={currentEventStartDate}
                    currentEventId={currentEventId}
                />
            )}
        </>
    );
};
